import React from 'react';
import './App.css';

import MainLayout from './layout/Mainlayout';


function App() {
  return (
    <div className="App">
      <MainLayout />
      
    </div>
  );
}

export default App;
